var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3058_9815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83366 1.66699V18.3337M14.167 1.66699V18.3337M1.66699 10.0003H18.3337M1.66699 5.83366H5.83366M1.66699 14.167H5.83366M14.167 14.167H18.3337M14.167 5.83366H18.3337M3.48366 1.66699H16.517C17.5203 1.66699 18.3337 2.48034 18.3337 3.48366V16.517C18.3337 17.5203 17.5203 18.3337 16.517 18.3337H3.48366C2.48034 18.3337 1.66699 17.5203 1.66699 16.517V3.48366C1.66699 2.48034 2.48034 1.66699 3.48366 1.66699Z",
    stroke: "#000000",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3058_9815"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilm);
export default __webpack_public_path__ + "static/media/film.806db357de3a21514d5ce1b694067e9b.svg";
export { ForwardRef as ReactComponent };